export default __webpack_public_path__ + "static/media/detective.381e82dc.png";